import { z } from 'zod';

import { ProfileTemplateScopeTypeSchema } from './shared.schemas.js';

export const RegisterProfileTemplateBodySchema = z.object({
  slug: z
    .string()
    .trim()
    .min(1)
    .max(64)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
  name: z.string().trim().min(1).max(120),
  description: z.string().trim().max(500).optional(),
  scopeType: ProfileTemplateScopeTypeSchema,
  permissionSlugs: z.array(z.string().trim().min(1)).min(1),
});

export type RegisterProfileTemplateBody = z.infer<typeof RegisterProfileTemplateBodySchema>;

export const RegisterProfileTemplateResponseSchema = z.object({
  id: z.uuid(),
});

export type RegisterProfileTemplateResponse = z.infer<typeof RegisterProfileTemplateResponseSchema>;
